import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import KottonseedCheckbox from 'src/app/(default)/_components/_common/Checkbox';
import KottonseedInput from 'src/app/(default)/_components/_common/Input';
import type { QnAFormData } from 'src/app/(default)/support/qna/write/_components';
import { useAppSelector } from 'src/store/client/config';
import { parseJwt } from 'src/utils/auth';
import mask from 'src/utils/mask';

import type { NormalUserLevel } from '@/store/server/common/auth/auth.dto';

const AnswerNoticeSection = () => {
  const { userInfo, userAuth } = useAppSelector((state) => state.user);

  const { setValue, watch } = useFormContext<QnAFormData>();

  const [renderSms, setRenderSms] = useState(true);
  const [renderEmail, setRenderEmail] = useState(true);

  const pushSms = watch('pushSms');
  const pushEmail = watch('pushEmail');

  const checkedSms = pushSms === 'Y';
  const checkedEmail = pushEmail === 'Y';

  const phoneNumber = mask.phoneNumber(userInfo?.phone ?? '');
  const email = userInfo?.mbr_id;

  const handleCheckboxClick = (type: 'sms' | 'email') => {
    if (type === 'sms') {
      setValue('pushSms', checkedSms ? 'N' : 'Y');
    }

    if (type === 'email') {
      setValue('pushEmail', checkedEmail ? 'N' : 'Y');
    }
  };

  useEffect(() => {
    if (userAuth) {
      const userLevel = parseJwt(userAuth.access_token)?.tokenUserLevel;
      const snsType = userInfo?.sns_type;

      const normalUserLevel: NormalUserLevel[] = ['K101', 'K102', 'K103', 'F103'];

      if (userLevel && normalUserLevel.includes(userLevel as NormalUserLevel)) {
        requestAnimationFrame(() => {
          // 일반회원 + 휴대폰 회원이면 이메일 렌더링 안함
          if (snsType === 'P') {
            setRenderEmail(false);

            // 일반회원 + 이메일 회원이면 문자 렌더링 안함
          } else {
            setRenderSms(false);
          }
        });
      }
    }
  }, [userAuth, userInfo]);

  return (
    <div>
      <p className="pb-4 typo-heading-5 text-text-basic">답변 알림</p>

      <div className="flex flex-col gap-2">
        {renderSms && (
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-0.5">
              <KottonseedCheckbox
                id="answer-notice-sms-checkbox"
                checked={checkedSms}
                onCheckedChange={() => handleCheckboxClick('sms')}
              />
              <label htmlFor="answer-notice-sms-checkbox" className="typo-body-2 text-text-caption-label">
                문자
              </label>
            </div>
            <KottonseedInput readOnly defaultValue={phoneNumber} />
          </div>
        )}

        {renderEmail && (
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-0.5">
              <KottonseedCheckbox
                id="answer-notice-email-checkbox"
                checked={checkedEmail}
                onCheckedChange={() => handleCheckboxClick('email')}
              />
              <label htmlFor="answer-notice-email-checkbox" className="typo-body-2 text-text-caption-label">
                이메일
              </label>
            </div>
            <KottonseedInput readOnly defaultValue={email} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AnswerNoticeSection;
